import { render } from "./calculator-icon.vue?vue&type=template&id=1d1853c9"
const script = {}
script.render = render

export default script